import { RefObject } from 'react';

export function getElement(refOrSelector: string | RefObject<HTMLElement>) {
    if (typeof refOrSelector === 'string') {
        return document.querySelector(refOrSelector);
    }

    return refOrSelector.current;
}

export function adjustPosition(element: HTMLElement, parent: HTMLElement, padding = {} as any) {
    const { offsetWidth: width, offsetHeight: height } = element;

    padding = { top: 10, left: 10, right: 10, bottom: 10, ...padding };

    let { offsetLeft: left, offsetTop: top } = element;
    left = Math.max(padding.left, Math.min(left, parent.clientWidth - width - padding.right));
    top = Math.max(padding.top, Math.min(top, parent.clientHeight - height - padding.bottom));

    element.style.left = left + 'px';
    element.style.top = top + 'px';
}

export const flowItemTypeEnum = {
    PROCESS_SCRIPT_TASK: 'Script',
    PROCESS_MESSAGE_RESPONSE_TASK: 'MessageResponse',
    PROCESS_MESSAGE_QUEUE_TASK: 'MessageQueue',
    PROCESS_HTTP_MESSAGE_TASK: 'HttpMessage',
    PROCESS_SUB_DECISION_TASK: 'SubDecision',
    PROCESS_SUB_PROCESS_TASK: 'SubProcess',
    PROCESS_SUB_PROCESS_START_TASK: 'SubProcessStart',
    PROCESS_CUSTOM_COMPONENTS: 'CustomComponents',
    PROCESS_RPA: 'RPA',
    PROCESS_RPA_START: 'RPAStart',
    PROCESS_SIGNAL_COMPONENTS: 'Signal',
    PROCESS_INVOKE_MODEL_INSTANCE: 'InvokeModelInstance',
    PROCESS_PARAMETERS_TABLE_TASK: 'ParametersTable',
};

export const flowItemTitle = {
    [flowItemTypeEnum.PROCESS_SCRIPT_TASK]: 'Script',
    [flowItemTypeEnum.PROCESS_MESSAGE_RESPONSE_TASK]: 'MessageResponse',
    [flowItemTypeEnum.PROCESS_MESSAGE_QUEUE_TASK]: 'MessageQueue',
    [flowItemTypeEnum.PROCESS_HTTP_MESSAGE_TASK]: 'HttpMessage',
    [flowItemTypeEnum.PROCESS_SUB_PROCESS_TASK]: 'SubProcess',
    [flowItemTypeEnum.PROCESS_SUB_DECISION_TASK]: 'SubDecision',
    [flowItemTypeEnum.PROCESS_SUB_PROCESS_START_TASK]: 'SubProcessStart',
    [flowItemTypeEnum.PROCESS_SIGNAL_COMPONENTS]: 'Signal',
    [flowItemTypeEnum.PROCESS_CUSTOM_COMPONENTS]: 'CustomComponents',
    [flowItemTypeEnum.PROCESS_RPA]: 'RPA',
    [flowItemTypeEnum.PROCESS_RPA_START]: 'RPAStart',
    [flowItemTypeEnum.PROCESS_INVOKE_MODEL_INSTANCE]: 'Model',
    [flowItemTypeEnum.PROCESS_PARAMETERS_TABLE_TASK]: 'ParametersTable',
};

export const flowItemsDescription = {
    [flowItemTypeEnum.PROCESS_SCRIPT_TASK]: 'Execute javascript code',
    [flowItemTypeEnum.PROCESS_MESSAGE_RESPONSE_TASK]: 'Respond to an event',
    [flowItemTypeEnum.PROCESS_HTTP_MESSAGE_TASK]: 'Make a HTTP service call',
    [flowItemTypeEnum.PROCESS_SUB_PROCESS_TASK]: 'Execute another process workflow and await to its end',
    [flowItemTypeEnum.PROCESS_SUB_DECISION_TASK]: 'Execute a decision workflow',
    [flowItemTypeEnum.PROCESS_SUB_PROCESS_START_TASK]:
        ' Start execution of another process without awaiting or awaiting for the first response',
    [flowItemTypeEnum.PROCESS_MESSAGE_QUEUE_TASK]: 'Send a message to the queue',
    [flowItemTypeEnum.PROCESS_SIGNAL_COMPONENTS]: 'Send a signal',
    [flowItemTypeEnum.PROCESS_RPA]: 'Rpa',
    [flowItemTypeEnum.PROCESS_RPA_START]: 'RPAStart',
    [flowItemTypeEnum.PROCESS_INVOKE_MODEL_INSTANCE]: 'Invoke model instance',
    [flowItemTypeEnum.PROCESS_PARAMETERS_TABLE_TASK]: 'Parameter table task',
};

// validators
const taskNameRegex = new RegExp(/^[\w_]{1,64}$/);
const nameValidator = (value: string) =>
    taskNameRegex.test(value)
        ? ''
        : 'Allowed characters: latin letters, digits and underscore. The maximum length is 64 characters.';

export const validators = {
    nameValidator,

    combine: (...validators: any[]) => {
        return (value: string) => {
            for (let validator of validators) {
                const result = validator(value);
                if (result) {
                    return result;
                }
            }
        };
    },
};

export const generateNameForItemType = (flowItemType: (typeof flowItemTypeEnum)[keyof typeof flowItemTypeEnum]) => {
    if (flowItemType === flowItemTypeEnum.PROCESS_INVOKE_MODEL_INSTANCE) {
        return 'InvokeModel';
    }

    return flowItemType;
};
